import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const goSection = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 300);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const links = [
    { label: "Viaturas", id: "catalog" },
    { label: "Sobre", id: "about" },
    { label: "Contactos", id: "contact" },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass border-b border-black/5">
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center group">
          <Logo className="h-10 sm:h-12" />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => goSection(l.id)}
              className="text-sm font-semibold text-muted-foreground hover:text-foreground transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button data-testid="nav-blog" onClick={() => { setOpen(false); navigate("/blog"); }} className="text-sm font-semibold text-muted-foreground hover:text-foreground transition-colors">Blog</button>
        </div>

        <button data-testid="nav-mobile-toggle" className="md:hidden p-2" onClick={() => setOpen(!open)}>
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden glass border-t border-black/5 px-5 py-4 flex flex-col gap-3">
          {links.map((l) => (
            <button key={l.id} onClick={() => goSection(l.id)} className="text-left py-2 font-semibold text-muted-foreground">
              {l.label}
            </button>
          ))}
          <button onClick={() => { setOpen(false); navigate("/blog"); }} className="text-left py-2 font-semibold text-muted-foreground">Blog</button>
        </div>
      )}
    </header>
  );
};
